module.exports = __webpack_public_path__ + "img/video-post.78b07621.png";